import React from 'react';
import { Flex, Segmented, Typography, theme } from 'antd';

import { useDashboardDateRange } from '../../context/DashboardDateRangeContext';

const { Text } = Typography;

const OPTIONS = [
  { label: 'Daily', value: 'day' },
  { label: 'Weekly', value: 'week' },
  { label: 'Monthly', value: 'month' }
];

/**
 * Bucket size (columns) for cash flow vs sales overview, persisted with dashboard date scope.
 *
 * @param {{ chart: 'cashFlow' | 'salesOverview' }} props
 */
const DashboardChartBucketToolbar = ({ chart }) => {
  const { token } = theme.useToken();
  const {
    cashFlowBuckets,
    setCashFlowBuckets,
    salesOverviewBuckets,
    setSalesOverviewBuckets
  } = useDashboardDateRange();

  const value = chart === 'cashFlow' ? cashFlowBuckets : salesOverviewBuckets;
  const onChange = chart === 'cashFlow' ? setCashFlowBuckets : setSalesOverviewBuckets;

  return (
    <Flex justify="flex-end" align="center" wrap="wrap" gap={token.paddingXS} className="mb-1">
      <Text type="secondary" style={{ fontSize: token.fontSizeSM }}>
        View by
      </Text>
      <Segmented size="small" options={OPTIONS} value={value} onChange={onChange} />
    </Flex>
  );
};

export default DashboardChartBucketToolbar;
